import React, { useEffect, useState } from "react";
import { getarchivedpage } from "../../Services/service";
import latestp1 from '../../assets/images/News/latest-post-11.jpeg'
import latestp2 from "../../assets/images/News/latest-post-12.jpeg";
import latestp3 from "../../assets/images/News/latest-post-13.jpeg";
import newyear from "../../assets/images/News/newyear.jpeg";

function Author() {
  const [archiveddata, setArchiveddata] = useState();
useEffect(() => {
  loadData();
},[])

async function loadData() {
  const res=await getarchivedpage()
  setArchiveddata(res)
}
console.log(archiveddata)
  return (
    <section className="binduz-er-author-item-area pb-20">
      {archiveddata && archiveddata.archivedpageinfo.map((item) => {
        return(
          <div className=" container">
        <div className="row">
          <div className=" col-lg-9">
            <div className="binduz-er-author-item mb-40">
              {/* <div className="binduz-er-thumb">
                <img
                  src={require(`../../assets/images/author-item-6.jpg`).default}
                  alt=""
                />
              </div> */}
              <div className="binduz-er-content">
                <div className="binduz-er-meta-item">
                  <div className="binduz-er-meta-categories">
                    <a href="#">{item.news}</a>
                  </div>
                  <div className="binduz-er-meta-date">
                    <span>
                      <i className="fal fa-calendar-alt"></i>{item.date}
                    </span>
                  </div>
                </div>
                <h3 className="binduz-er-title">
                  <a href="#">
                  {item.p1}
                  </a>
                </h3>
                <div className="binduz-er-meta-author">
                  <div className="binduz-er-author">
                    <img
                      src={require(`../../assets/images/user-2.jpg`).default}
                      alt=""
                    />
                    <span>
                      <span>{item.author}</span>
                    </span>
                  </div>
                  <div className="binduz-er-meta-list">
                    <ul>
                      <li>
                        <i className="fal fa-eye"></i> {item.views}
                      </li>
                      <li>
                        <i className="fal fa-heart"></i> {item.views}
                      </li>
                      <li>
                        <i className="fal fa-comments"></i> {item.views}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="binduz-er-author-item mb-40">
              <div className="binduz-er-thumb">
                <img
                  src={require(`../../assets/images/author-item-5.jpg`).default}
                  alt=""
                />
              </div>
              <div className="binduz-er-content">
                <div className="binduz-er-meta-item">
                  <div className="binduz-er-meta-categories">
                    <a href="#">{item.news}</a>
                  </div>
                  <div className="binduz-er-meta-date">
                    <span>
                      <i className="fal fa-calendar-alt"></i>{item.date1}
                    </span>
                  </div>
                </div>
                <h3 className="binduz-er-title">
                  <a href="#">
                  {item.p2}
                    </a>
                </h3>
                <div className="binduz-er-meta-author">
                  <div className="binduz-er-author">
                    <img
                      src={require(`../../assets/images/user-2.jpg`).default}
                      alt=""
                    />
                    <span>
                      <span>{item.author}</span>
                    </span>
                  </div>
                  <div className="binduz-er-meta-list">
                    <ul>
                      <li>
                        <i className="fal fa-eye"></i> {item.views}
                      </li>
                      <li>
                        <i className="fal fa-heart"></i> {item.views}
                      </li>
                      <li>
                        <i className="fal fa-comments"></i> {item.views}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="binduz-er-author-item mb-40">
              <div className="binduz-er-thumb">
                <img
                  src={require(`../../assets/images/author-item-4.jpg`).default}
                  alt=""
                />
              </div>
              <div className="binduz-er-content">
                <div className="binduz-er-meta-item">
                  <div className="binduz-er-meta-categories">
                    <a href="#">{item.news}</a>
                  </div>
                  <div className="binduz-er-meta-date">
                    <span>
                      <i className="fal fa-calendar-alt"></i>{item.date2}
                    </span>
                  </div>
                </div>
                <h3 className="binduz-er-title">
                  <a href="#">
                  {item.p3}
                  </a>
                </h3>
                <div className="binduz-er-meta-author">
                  <div className="binduz-er-author">
                    <img
                      src={require(`../../assets/images/user-2.jpg`).default}
                      alt=""
                    />
                    <span>
                      <span>{item.author}</span>
                    </span>
                  </div>
                  <div className="binduz-er-meta-list">
                    <ul>
                      <li>
                        <i className="fal fa-eye"></i> {item.views}
                      </li>
                      <li>
                        <i className="fal fa-heart"></i> {item.views}
                      </li>
                      <li>
                        <i className="fal fa-comments"></i> {item.views}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="binduz-er-author-item mb-40">
              <div className="binduz-er-thumb">
                <img
                  src={require(`../../assets/images/author-item-3.jpg`).default}
                  alt=""
                />
              </div>
              <div className="binduz-er-content">
                <div className="binduz-er-meta-item">
                  <div className="binduz-er-meta-categories">
                    <a href="#">{item.news}</a>
                  </div>
                  <div className="binduz-er-meta-date">
                    <span>
                      <i className="fal fa-calendar-alt"></i>{item.date3}
                    </span>
                  </div>
                </div>
                <h3 className="binduz-er-title">
                  <a href="#">
                  {item.p4}
                  </a>
                </h3>
                <div className="binduz-er-meta-author">
                  <div className="binduz-er-author">
                    <img
                      src={require(`../../assets/images/user-2.jpg`).default}
                      alt=""
                    />
                    <span>
                      <span>{item.author}</span>
                    </span>
                  </div>
                  <div className="binduz-er-meta-list">
                    <ul>
                      <li>
                        <i className="fal fa-eye"></i> {item.views}
                      </li>
                      <li>
                        <i className="fal fa-heart"></i> {item.views}
                      </li>
                      <li>
                        <i className="fal fa-comments"></i> {item.views}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="binduz-er-author-item mb-40">
              <div className="binduz-er-thumb">
                <img
                  src={require(`../../assets/images/author-item-2.jpg`).default}
                  alt=""
                />
              </div>
              <div className="binduz-er-content">
                <div className="binduz-er-meta-item">
                  <div className="binduz-er-meta-categories">
                    <a href="#">{item.news}</a>
                  </div>
                  <div className="binduz-er-meta-date">
                    <span>
                      <i className="fal fa-calendar-alt"></i>{item.date4}
                    </span>
                  </div>
                </div>
                <h3 className="binduz-er-title">
                  <a href="#">
                  {item.p5}
                  </a>
                </h3>
                <div className="binduz-er-meta-author">
                  <div className="binduz-er-author">
                    <img
                      src={require(`../../assets/images/user-2.jpg`).default}
                      alt=""
                    />
                    <span>
                      <span>{item.author}</span>
                    </span>
                  </div>
                  <div className="binduz-er-meta-list">
                    <ul>
                      <li>
                        <i className="fal fa-eye"></i> {item.views}
                      </li>
                      <li>
                        <i className="fal fa-heart"></i> {item.views}
                      </li>
                      <li>
                        <i className="fal fa-comments"></i> {item.views}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="binduz-er-author-item mb-40">
              <div className="binduz-er-thumb">
                <img
                  src={require(`../../assets/images/author-item-1.jpg`).default}
                  alt=""
                />
              </div>
              <div className="binduz-er-content">
                <div className="binduz-er-meta-item">
                  <div className="binduz-er-meta-categories">
                    <a href="#">{item.news}</a>
                  </div>
                  <div className="binduz-er-meta-date">
                    <span>
                      <i className="fal fa-calendar-alt"></i>{item.date5}
                    </span>
                  </div>
                </div>
                <h3 className="binduz-er-title">
                  <a href="#">
                  {item.p6}
                  </a>
                </h3>
                <div className="binduz-er-meta-author">
                  <div className="binduz-er-author">
                    <img
                      src={require(`../../assets/images/user-2.jpg`).default}
                      alt=""
                    />
                    <span>
                      <span>{item.author}</span>
                    </span>
                  </div>
                  <div className="binduz-er-meta-list">
                    <ul>
                      <li>
                        <i className="fal fa-eye"></i> {item.views}
                      </li>
                      <li>
                        <i className="fal fa-heart"></i> {item.views}
                      </li>
                      <li>
                        <i className="fal fa-comments"></i> {item.views}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" col-lg-3">
            <div className="binduz-er-populer-news-sidebar">
              <div className="binduz-er-archived-sidebar-about">
                <div className="binduz-er-user">
                  <img
                    src={
                      require(`../../assets/images/archived-about.png`).default
                    }
                    alt=""
                  />
                  <div className="binduz-er-icon">
                    <i className="fal fa-newspaper"></i>
                  </div>
                </div>
                <span>{item.seniorrep}</span>
                <h4 className="binduz-er-title">{item.seniorrepname}</h4>
                <ul>
                  <li>
                    <a href="#">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-behance"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>

              <div className="binduz-er-author-sidebar-search-bar">
                <form action="#">
                  <div className="binduz-er-input-box">
                    <input type="text" placeholder="Search from here..." />
                    <button type="button">
                      <i className="fal fa-search"></i>
                    </button>
                  </div>
                </form>
              </div>

              <div className="binduz-er-populer-news-sidebar-post pt-40">
                <div className="binduz-er-popular-news-title">
                  <ul
                    className="nav nav-pills mb-3"
                    id="pills-tab-2"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <a
                        className="nav-link active"
                        id="pills-home-tab"
                        data-bs-toggle="pill"
                        href="#pills-home"
                        role="tab"
                        aria-controls="pills-home"
                        aria-selected="true"
                      >
                        {item.mp}
                      </a>
                    </li>
                    {/* <li className="nav-item" role="presentation">
                      <a
                        className="nav-link"
                        id="pills-profile-tab"
                        data-bs-toggle="pill"
                        href="#pills-profile"
                        role="tab"
                        aria-controls="pills-profile"
                        aria-selected="false"
                      >
                        Most Recent
                      </a>
                    </li> */}
                  </ul>
                </div>
                <div className="tab-content" id="pills-tabContent-2">
                  <div
                    className="tab-pane fade show active"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    <div className="binduz-er-sidebar-latest-post-box">
                      <div className="binduz-er-sidebar-latest-post-item">
                        <div className="binduz-er-thumb">
                          {/* <img
                            src={
                              require(`../../assets/images/latest-post-1.jpg`)
                                .default
                            }
                            alt="latest"
                          /> */}
                          <img src={latestp1} alt="" />
                        </div>
                        <div className="binduz-er-content">
                          <span>
                            <i className="fal fa-calendar-alt"></i> {item.date6}
                          </span>
                          <h4 className="binduz-er-title">
                            <a href="#">
                            {item.p7}
                            </a>
                          </h4>
                        </div>
                      </div>
                      <div className="binduz-er-sidebar-latest-post-item">
                        <div className="binduz-er-thumb">
                          {/* <img
                            src={
                              require(`../../assets/images/latest-post-2.jpg`)
                                .default
                            }
                            alt="latest"
                          /> */}
                          <img src={latestp2} alt="" />
                        </div>
                        <div className="binduz-er-content">
                          <span>
                            <i className="fal fa-calendar-alt"></i>{item.date7}
                          </span>
                          <h4 className="binduz-er-title">
                            <a href="#">
                              {item.p8}
                            </a>
                          </h4>
                        </div>
                      </div>
                      <div className="binduz-er-sidebar-latest-post-item">
                        <div className="binduz-er-thumb">
                          {/* <img
                            src={
                              require(`../../assets/images/latest-post-3.jpg`)
                                .default
                            }
                            alt="latest"
                          /> */}
                          <img src={latestp3} alt="" />
                        </div>
                        <div className="binduz-er-content">
                          <span>
                            <i className="fal fa-calendar-alt"></i> {item.date8}
                          </span>
                          <h4 className="binduz-er-title">
                            <a href="#">
                              {item.p9}
                            </a>
                          </h4>
                        </div>
                      </div>
                      <div className="binduz-er-sidebar-latest-post-item">
                        <div className="binduz-er-thumb">
                          {/* <img
                            src={
                              require(`../../assets/images/latest-post-4.jpg`)
                                .default
                            }
                            alt="latest"
                          /> */}
                          <img src={newyear} alt="" />
                        </div>
                        <div className="binduz-er-content">
                          <span>
                            <i className="fal fa-calendar-alt"></i> {item.date9}
                          </span>
                          <h4 className="binduz-er-title">
                            <a href="#">
                              {item.p10}
                            </a>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div
                    className="tab-pane fade"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    <div className="binduz-er-sidebar-latest-post-box">
                      <div className="binduz-er-sidebar-latest-post-item">
                        <div className="binduz-er-thumb">
                          <img
                            src={
                              require(`../../assets/images/latest-post-1.jpg`)
                                .default
                            }
                            alt="latest"
                          />
                        </div>
                        <div className="binduz-er-content">
                          <span>
                            <i className="fal fa-calendar-alt"></i> 24th
                            February 2020
                          </span>
                          <h4 className="binduz-er-title">
                            <a href="#">
                              Why creating inclusive classrooms matters
                            </a>
                          </h4>
                        </div>
                      </div>
                      <div className="binduz-er-sidebar-latest-post-item">
                        <div className="binduz-er-thumb">
                          <img
                            src={
                              require(`../../assets/images/latest-post-2.jpg`)
                                .default
                            }
                            alt="latest"
                          />
                        </div>
                        <div className="binduz-er-content">
                          <span>
                            <i className="fal fa-calendar-alt"></i> 24th
                            February 2020
                          </span>
                          <h4 className="binduz-er-title">
                            <a href="#">
                              Celebrating Asian Pacific American art and
                            </a>
                          </h4>
                        </div>
                      </div>
                      <div className="binduz-er-sidebar-latest-post-item">
                        <div className="binduz-er-thumb">
                          <img
                            src={
                              require(`../../assets/images/latest-post-3.jpg`)
                                .default
                            }
                            alt="latest"
                          />
                        </div>
                        <div className="binduz-er-content">
                          <span>
                            <i className="fal fa-calendar-alt"></i> 24th
                            February 2020
                          </span>
                          <h4 className="binduz-er-title">
                            <a href="#">
                              From overcoming burnout to finding new
                            </a>
                          </h4>
                        </div>
                      </div>
                      <div className="binduz-er-sidebar-latest-post-item">
                        <div className="binduz-er-thumb">
                          <img
                            src={
                              require(`../../assets/images/latest-post-4.jpg`)
                                .default
                            }
                            alt="latest"
                          />
                        </div>
                        <div className="binduz-er-content">
                          <span>
                            <i className="fal fa-calendar-alt"></i> 24th
                            February 2020
                          </span>
                          <h4 className="binduz-er-title">
                            <a href="#">
                              Sparks of inspiration to the new trend 2021
                            </a>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>

              <div className="binduz-er-populer-news-sidebar-newsletter binduz-er-author-page-newsletter mt-40">
                <div className="binduz-er-newsletter-box text-center">
                  <img
                    src={require(`../../assets/images/icon/icon-3.png`).default}
                    alt=""
                  />
                  <h3 className="binduz-er-title">{item.sc}</h3>
                  <p>{item.sc2}</p>
                  <div className="binduz-er-input-box">
                    <input type="text" placeholder="Enter your email" />
                    <button type="button">
                      <i className="fal fa-long-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div className="binduz-er-populer-news-social binduz-er-author-page-social mt-40">
                <div className="binduz-er-popular-news-title">
                  <h3 className="binduz-er-title">{item.socialcon}</h3>
                </div>
                <div className="binduz-er-social-list">
                  <div className="binduz-er-list">
                    <a href="#">
                      <span>
                        <i className="fab fa-facebook-f"></i> <span>{item.likec}</span>{" "}
                        {item.likes}
                      </span>
                      <span>{item.like}</span>
                    </a>
                    <a href="#">
                      <span>
                        <i className="fab fa-twitter"></i> <span>{item.likec}</span>{" "}
                        {item.likes}
                      </span>
                      <span>{item.twitter}</span>
                    </a>
                    <a href="#">
                      <span>
                        <i className="fab fa-behance"></i> <span>{item.views}+</span>{" "}
                        {item.follower}
                      </span>
                      <span>{item.follow}</span>
                    </a>
                    <a href="#">
                      <span>
                        <i className="fab fa-youtube"></i> <span>{item.likec}</span>{" "}
                        {item.subscribe}
                      </span>
                      <span>{item.subscribe}</span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="binduz-er-populer-news-social binduz-er-author-page-social mt-40">
                <div className="binduz-er-popular-news-title">
                  <h3 className="binduz-er-title">{item.videop}</h3>
                </div>
                <div className="binduz-er-video-post binduz-er-recently-viewed-item">
                  <div className="binduz-er-latest-news-item">
                    <div className="binduz-er-thumb">
                      <img
                        src="assets/images/editors-pack-thumb-1.jpg"
                        alt=""
                      />
                      <div className="binduz-er-play">
                        <a href="#">
                          <i className="fas fa-play"></i>
                        </a>
                      </div>
                    </div>
                    <div className="binduz-er-content">
                      <div className="binduz-er-meta-item">
                        <div className="binduz-er-meta-categories">
                          <a href="#">{item.news}</a>
                        </div>
                        <div className="binduz-er-meta-date">
                          <span>
                            <i className="fal fa-calendar-alt"></i>{item.date10}
                          </span>
                        </div>
                      </div>
                      <h5 className="binduz-er-title">
                        <a href="#">
                          {item.p11}
                        </a>
                      </h5>
                      <div className="binduz-er-meta-author">
                        <span>
                          <span>{item.author}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="binduz-er-sidebar-social binduz-er-populer-news-sidebar-add d-none d-lg-block">
                <div className="binduz-er-sidebar-add mt-40">
                  <h3 className="binduz-er-title">
                  {item.business1}<span>{item.business2}</span>
                  </h3>
                  <a className="binduz-er-main-btn" href="#">
                  {item.purchase}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      )})}
    </section>
  );
}

export default Author;
